import { FC, Fragment } from "react";

export type LabelLoginprops = {
  texto: string;
  htmlFor: string;
};

export const LabelLogin: FC<LabelLoginprops> = ({ htmlFor, texto }) => {
  return (
    <Fragment>
      <label
        htmlFor={htmlFor}
        className="block text-sm font-medium leading-6 text-gray-900"
      >
        {texto}
      </label>
    </Fragment>
  );
};
